import ContentWrapper from 'components/ContentWrapper';
import { Button, TextField, Typography, Divider } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import NumberFormat from 'components/NumberFormat';
import Row from './Row';
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { useStyles } from '../../styles';


export const FanComps = ({control, totalPrice, setTotalPrice, calcTotalPrice}) => {

    const classes = useStyles();
    
    const { fields, append, remove } = useFieldArray({
        control,
        name: "lineItems"
        });
        
        
    // const requiredFields = fields.map((field, index) => 
    //     !field.isOptional ? { ...field, originalIndex: index } : null
    // ).filter(Boolean);

    // const optionalFields = fields.map((field, index) => 
    //     field.isOptional ? { ...field, originalIndex: index } : null
    // ).filter(Boolean);

    return (
        <>
            <ContentWrapper>
                <Typography variant="h4" gutterBottom>
                    Model/Duty
                </Typography>
                <br />

                <SelectWithDataReactHook
                    name='attributes.designation'
                    type='text'
                    control={control}
                    label='Designation'
                    options={[
                        {
                            label: 'Centrifugal Fan',
                            id: 'Centrifugal Fan'
                        },
                        {
                            label: 'Material Handling Fan',
                            id: 'Material Handling Fan'
                        },
                        {
                            label: 'Dust Fan',
                            id: 'Dust Fan'
                        },
                        {
                            label: 'Axial Flow Fan',
                            id: 'Axial Flow Fan'
                        },
                        {
                            label: 'Side Channel Blower',
                            id: 'Side Channel Blower'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                /> 
                
                <Divider />
                <br />

                <ReactHookTextField
                    name='attributes.fanHanding'
                    type='text'
                    control={control}
                    label={`Handing`}
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.fanOrt'
                    type='text'
                    control={control}
                    label={`Orientation`}
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.FanPercentageWidth'
                    type='text'
                    control={control}
                    label={`% Width`}
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.fanWidth'
                    type='text'
                    control={control}
                    label='Fan Width'
                    style={{width: '19%', marginRight: '1%'}}
                />

                <ReactHookTextField
                    name='attributes.fanDutyDensity'
                    type='text'
                    control={control}
                    label='Duty Density'
                    style={{width: '19%', marginRight: '1%'}}
                />
                
                <Divider />
                <br />

                <ReactHookTextField
                    name='attributes.fanVolume'
                    type='text'
                    control={control}
                    label={`Volume`}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.fanVolumeLabel'
                    type='text'
                    control={control}
                    label={`Volume Unit`}
                    options={[
                        {
                            label: 'CFM',
                            id: 'CFM'
                        },
                        {
                            label: 'M3/HR',
                            id: 'M3/HR'
                        },
                        {
                            label: 'M3/MIN',
                            id: 'M3/MIN'
                        },
                        {
                            label: 'M3/SEC',
                            id: 'M3/SEC'
                        },
                        {
                            label: 'L/S',
                            id: 'L/S'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanInletPressure'
                    type='text'
                    control={control}
                    label={`Inlet Pressure`}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDischargePressure'
                    type='text'
                    control={control}
                    label={`Discharge Pressure`}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.fanPressureLabel'
                    type='text'
                    control={control}
                    label={`Pressure Unit`}
                    options={[
                        {
                            label: 'IN WG',
                            id: 'IN WG'
                        },
                        {
                            label: 'MM W.G.',
                            id: 'MM W.G.'
                        },
                        {
                            label: 'KPA',
                            id: 'KPA'
                        },
                        {
                            label: 'PA',
                            id: 'PA'
                        },
                        {
                            label: 'MBAR',
                            id: 'MBAR'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanRpm'
                    type='text'
                    control={control}
                    label='RPM'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDesignTempC'
                    type='text'
                    control={control}
                    label='Design Temp (C)'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDutyKW'
                    type='text'
                    control={control}
                    label='Duty kW'
                    style={{width: '19%', marginRight: '1%'}}
                />

                <Divider />
                <br />
                
                <ReactHookTextField
                    name='attributes.fanQty'
                    type='text'
                    control={control}
                    label='Qty'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanDesign'
                    type='text'
                    control={control}
                    label='Design'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.fanSize'
                    type='text'
                    control={control}
                    label='Size'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <ReactHookTextField
                    name='attributes.impellerDiameter'
                    type='text'
                    control={control}
                    label='Impeller Dia. mm'
                    style={{width: '19%', marginRight: '1%'}}
                />

                <SelectWithDataReactHook
                    name='attributes.fanDrive'
                    control={control}
                    label='Drive'
                    options={[
                        {
                            label: 'Belt',
                            id: 'Belt'
                        },
                        {
                            label: 'Direct',
                            id: 'Direct'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />         
                <SelectWithDataReactHook
                    name='attributes.fanArrangement'
                    type='text'
                    control={control}
                    label='Arrangement'
                    creatable={true}
                    options={[
                        {
                            label: '1',
                            id: '1'
                        },
                        {
                            label: '2',
                            id: '2'
                        },
                        {
                            label: '4',
                            id: '4'
                        },
                        {
                            label: '4F',
                            id: '4F'
                        },
                        {
                            label: '9',
                            id: '9'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />         
                <SelectWithDataReactHook
                    name='attributes.fanIdRating'
                    type='text'
                    control={control}
                    label='ID Rating'
                    options={[
                        {
                            label: 'ID1',
                            id: 'ID1'
                        },
                        {
                            label: 'ID2',
                            id: 'ID2'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                /> 
                <SelectWithDataReactHook
                    name='attributes.impellerType'
                    type='text'
                    control={control}
                    label='Type'
                    options={[
                        {
                            label: 'Backward Inclined',
                            id: 'Backward Inclined'
                        },
                        {
                            label: 'Laminar',
                            id: 'Laminar'
                        },
                        {
                            label: 'Axial',
                            id: 'Axial'
                        },
                        {
                            label: 'Aerofoil',
                            id: 'Aerofoil'
                        },
                        {
                            label: 'Radial',
                            id: 'Radial'
                        },
                        {
                            label: 'Radial Tip',
                            id: 'Radial Tip'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />          
                <br />
                <ReactHookTextField
                    name='attributes.fanOther'
                    type='text'
                    control={control}
                    label='Items Included In Price'
                    InputProps={{
                        multiline:true
                    }}
                    style={{width: '39%', marginRight: '1%'}}
                />

                <br />
                <br />
                <Divider />
                <br />

                <Typography variant="h4" gutterBottom>
                    Motor
                </Typography>
                <br />

                <ReactHookTextField
                    name='attributes.motorMake'
                    type='text'
                    control={control}
                    label='Make'
                    style={{width: '19%', marginRight: '1%'}}
                />  

                <ReactHookTextField
                    name='attributes.motorFrame'
                    type='text'
                    control={control}
                    label='Frame'
                    style={{width: '19%', marginRight: '1%'}}
                />  

                <ReactHookTextField
                    name='attributes.motorTerminalBox'
                    type='text'
                    control={control}
                    label='TerminalBox'
                    style={{width: '19%', marginRight: '1%'}}
                />  

                <ReactHookTextField
                    name='attributes.motorKW'
                    type='text'
                    control={control}
                    label='kW'
                    style={{width: '19%', marginRight: '1%'}}
                />    
                <ReactHookTextField
                    name='attributes.motorSpeed'
                    type='text'
                    control={control}
                    label='Speed'
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.motorPowerSupply'
                    type='text'
                    control={control}
                    label='Power Supply'
                    creatable={true}
                    options={[
                        {
                            label: '415V/3PH/50HZ',
                            id: '415V/3PH/50HZ'
                        },
                        {
                            label: '240V/1PH/50HZ',
                            id: '240V/1PH/50HZ'
                        },
                        {
                            label: '380V/1PH/50HZ',
                            id: '380V/1PH/50HZ'
                        },
                        {
                            label: '480V/1PH/50HZ',
                            id: '480V/1PH/50HZ'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />                    
                <SelectWithDataReactHook
                    name='attributes.motorProtection'
                    type='text'
                    control={control}
                    label='Protection'
                    creatable={true}
                    options={[
                        {
                            label: 'TEFC - IP55',
                            id: 'TEFC - IP55'
                        },
                        {
                            label: 'D.I.P',
                            id: 'D.I.P'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.motorPole'
                    type='text'
                    control={control}
                    label='Pole'
                    options={[
                        {
                            label: '2',
                            id: '2'
                        },
                        {
                            label: '4',
                            id: '4'
                        },
                        {
                            label: '6',
                            id: '6'
                        },
                        {
                            label: '8',
                            id: '8'
                        },
                        {
                            label: '10',
                            id: '10'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                <SelectWithDataReactHook
                    name='attributes.motorDesign'
                    type='text'
                    control={control}
                    label='Design'
                    creatable={true}
                    options={[
                        {
                            label: 'Ex e, Class 1, Zone 1',
                            id: 'Ex e, Class 1, Zone 1'
                        },
                        {
                            label: 'Ex d Flameproof',
                            id: 'Ex d Flameproof'
                        },
                        {
                            label: 'Thermistors',
                            id: 'Thermistors'
                        }
                    ]}
                    style={{width: '19%', marginRight: '1%'}}
                />
                            
                <ReactHookTextField
                    name='attributes.motorOther'
                    type='text'
                    control={control}
                    label='Other'
                    InputProps={{
                        multiline:true
                    }}
                    style={{width: '39%', marginRight: '1%'}}
                />
            
                <br />
                <br />
                <Divider />
                <br />

                <Typography variant="h4" gutterBottom>
                    Finishing
                </Typography>
                <br />

                <SelectWithDataReactHook
                    name='attributes.internalCoatingType'
                    type='text'
                    control={control}
                    label='Internal'
                    creatable={true}
                    options={[
                        {
                            label: 'URE : Blast Class 2.5, 50-75µm intercure (Zn), 50µm interthane (URE) TDFT 100-125µm',
                            id: 'URE : Blast Class 2.5, 50-75µm intercure (Zn), 50µm interthane (URE) TDFT 100-125µm',
                        },
                        {
                            label: 'ZEP : Blast Class 2.5, 50-75µm interzinc 52 TDFT 50-75µm',
                            id: 'ZEP : Blast Class 2.5, 50-75µm interzinc 52 TDFT 50-75µm',
                        },
                        {
                            label: 'ZPH : Blast Class 2.5, 50-75µm intercure 200 TDFT 50-75µm',
                            id: 'ZPH : Blast Class 2.5, 50-75µm intercure 200 TDFT 50-75µm',
                        },
                        {
                            label: 'IOZ : Blast Class 2.5, 60-90µm interzinc 2280 TDFT 60-90µm',
                            id: 'IOZ : Blast Class 2.5, 60-90µm interzinc 2280 TDFT 60-90µm',
                        },
                        {
                            label: 'HBE : Blast Class 2.5, Two coats 125',
                            id: 'HBE : Blast Class 2.5, Two coats 125',
                        },
                        {
                            label: 'HBU : Blast Class 2.5, 50-75µm intercure (Zn), 125-175µm interplus, 50µm interthane (URE) TDFT 225-300µm',
                            id: 'HBU : Blast Class 2.5, 50-75µm intercure (Zn), 125-175µm interplus, 50µm interthane (URE) TDFT 225-300µm',
                        },
                        {
                            label: 'HTA : Blast Class 2.5, Two coats 25µm Intertherm (AL) TDFT 50µm',
                            id: 'HTA : Blast Class 2.5, Two coats 25µm Intertherm (AL) TDFT 50µm',
                        },
                        {
                            label: 'NIL : No Paint',
                            id: 'NIL : No Paint',
                        },
                        {
                            label: 'BST : Blast Only',
                            id: 'BST : Blast Only',
                        },
                        {
                            label: 'PAS : Passivate Weld Areas',
                            id: 'PAS : Passivate Weld Areas',
                        },
                        {
                            label: 'SCE : Blast Class 2.5, 125-150µm interplus TDFT 125-150µm',
                            id: 'SCE : Blast Class 2.5, 125-150µm interplus TDFT 125-150µm',
                        },
                        {
                            label: 'ABR : Abrasion resistant ceramic filled epoxy two coats CERAMKOTE TDFT 175-250µm',
                            id: 'ABR : Abrasion resistant ceramic filled epoxy two coats CERAMKOTE TDFT 175-250µm',
                        },
                        {
                            label: 'ENA : Standard enamel (Dulux Luxol 4QD or similar) 1 Coat + 1 Coat GOZP',
                            id: 'ENA : Standard enamel (Dulux Luxol 4QD or similar) 1 Coat + 1 Coat GOZP',
                        },
                        {
                            label: 'GOZ : 1 Coat GOZP',
                            id: 'GOZ : 1 Coat GOZP',
                        },
                        {
                            label: 'HAL : High Temperature AL Coating',
                            id: 'HAL : High Temperature AL Coating',
                        },
                        {
                            label: 'OTH : As per client specification',
                            id: 'OTH : As per client specification',
                        },
                        {
                            label: '1-Pack : Standard Primer',
                            id: '1-Pack : Standard Primer',
                        },
                        {
                            label: '1-Pack : Standard Primer + Standard Enamel',
                            id: '1-Pack : Standard Primer + Standard Enamel',
                        },
                        {
                            label: '2-Pack : Epoxy Primer – 75µm DFT',
                            id: '2-Pack : Epoxy Primer – 75µm DFT',
                        },
                        {
                            label: '2-Pack : Epoxy Primer + Polyurethane Top Coat – 125µm DFT',
                            id: '2-Pack : Epoxy Primer + Polyurethane Top Coat – 125µm DFT',
                        },
                        {
                            label: 'High Build : Epoxy Primer + Polyurethane Top Coat – 200-225µm DFT',
                            id: 'High Build : Epoxy Primer + Polyurethane Top Coat – 200-225µm DFT',
                        },
                        {
                            label: 'Hi-Temp : 2-Coats Silicone High Temp (Rated <435°C) – 40µm DFT',
                            id: 'Hi-Temp : 2-Coats Silicone High Temp (Rated <435°C) – 40µm DFT',
                        },
                    ]}
                    style={{width: '39%', marginRight: '1%'}}
                />    
                <SelectWithDataReactHook
                    name='attributes.externalCoatingType'
                    type='text'
                    control={control}
                    label='External'
                    creatable={true}
                    options={[
                        
                        {
                            label: 'URE : Blast Class 2.5, 50-75µm intercure (Zn), 50µm interthane (URE) TDFT 100-125µm',
                            id: 'URE : Blast Class 2.5, 50-75µm intercure (Zn), 50µm interthane (URE) TDFT 100-125µm',
                        },
                        {
                            label: 'ZEP : Blast Class 2.5, 50-75µm interzinc 52 TDFT 50-75µm',
                            id: 'ZEP : Blast Class 2.5, 50-75µm interzinc 52 TDFT 50-75µm',
                        },
                        {
                            label: 'ZPH : Blast Class 2.5, 50-75µm intercure 200 TDFT 50-75µm',
                            id: 'ZPH : Blast Class 2.5, 50-75µm intercure 200 TDFT 50-75µm',
                        },
                        {
                            label: 'IOZ : Blast Class 2.5, 60-90µm interzinc 2280 TDFT 60-90µm',
                            id: 'IOZ : Blast Class 2.5, 60-90µm interzinc 2280 TDFT 60-90µm',
                        },
                        {
                            label: 'HBE : Blast Class 2.5, Two coats 125',
                            id: 'HBE : Blast Class 2.5, Two coats 125',
                        },
                        {
                            label: 'HBU : Blast Class 2.5, 50-75µm intercure (Zn), 125-175µm interplus, 50µm interthane (URE) TDFT 225-300µm',
                            id: 'HBU : Blast Class 2.5, 50-75µm intercure (Zn), 125-175µm interplus, 50µm interthane (URE) TDFT 225-300µm',
                        },
                        {
                            label: 'HTA : Blast Class 2.5, Two coats 25µm Intertherm (AL) TDFT 50µm',
                            id: 'HTA : Blast Class 2.5, Two coats 25µm Intertherm (AL) TDFT 50µm',
                        },
                        {
                            label: 'NIL : No Paint',
                            id: 'NIL : No Paint',
                        },
                        {
                            label: 'BST : Blast Only',
                            id: 'BST : Blast Only',
                        },
                        {
                            label: 'PAS : Passivate Weld Areas',
                            id: 'PAS : Passivate Weld Areas',
                        },
                        {
                            label: 'SCE : Blast Class 2.5, 125-150µm interplus TDFT 125-150µm',
                            id: 'SCE : Blast Class 2.5, 125-150µm interplus TDFT 125-150µm',
                        },
                        {
                            label: 'ABR : Abrasion resistant ceramic filled epoxy two coats CERAMKOTE TDFT 175-250µm',
                            id: 'ABR : Abrasion resistant ceramic filled epoxy two coats CERAMKOTE TDFT 175-250µm',
                        },
                        {
                            label: 'ENA : Standard enamel (Dulux Luxol 4QD or similar) 1 Coat + 1 Coat GOZP',
                            id: 'ENA : Standard enamel (Dulux Luxol 4QD or similar) 1 Coat + 1 Coat GOZP',
                        },
                        {
                            label: 'GOZ : 1 Coat GOZP',
                            id: 'GOZ : 1 Coat GOZP',
                        },
                        {
                            label: 'HAL : High Temperature AL Coating',
                            id: 'HAL : High Temperature AL Coating',
                        },
                        {
                            label: 'OTH : As per client specification',
                            id: 'OTH : As per client specification',
                        },
                        {
                            label: '1-Pack : Standard Primer',
                            id: '1-Pack : Standard Primer',
                        },
                        {
                            label: '1-Pack : Standard Primer + Standard Enamel',
                            id: '1-Pack : Standard Primer + Standard Enamel',
                        },
                        {
                            label: '2-Pack : Epoxy Primer – 75µm DFT',
                            id: '2-Pack : Epoxy Primer – 75µm DFT',
                        },
                        {
                            label: '2-Pack : Epoxy Primer + Polyurethane Top Coat – 125µm DFT',
                            id: '2-Pack : Epoxy Primer + Polyurethane Top Coat – 125µm DFT',
                        },
                        {
                            label: 'High Build : Epoxy Primer + Polyurethane Top Coat – 200-225µm DFT',
                            id: 'High Build : Epoxy Primer + Polyurethane Top Coat – 200-225µm DFT',
                        },
                        {
                            label: 'Hi-Temp : 2-Coats Silicone High Temp (Rated <435°C) – 40µm DFT',
                            id: 'Hi-Temp : 2-Coats Silicone High Temp (Rated <435°C) – 40µm DFT',
                        },
                    ]}
                    style={{width: '39%', marginRight: '1%'}}
                />  
                <ReactHookTextField
                    name='attributes.externalCoatingColour'
                    type='text'
                    control={control}
                    label='Colour'
                    style={{width: '19%', marginRight: '1%'}}
                />

                <br />
                <br />
                <Divider />
                <br />

                <Typography variant="h4" gutterBottom>
                    Commercials
                </Typography>
                <br />

                <ReactHookTextField
                    name='attributes.fanEstimatedCost'
                    type='text'
                    control={control}
                    label='Fan Estimated Cost'
                    style={{width: '19%', marginRight: '1%'}}
                    InputProps={{
                        inputComponent: NumberFormat,
                    }}
                />

                <ReactHookTextField
                    name='attributes.fanSellPrice'
                    type='text'
                    control={control}
                    label='Fan Sell Price'
                    style={{width: '19%', marginRight: '1%'}}
                    InputProps={{
                        inputComponent: NumberFormat,
                    }}
                />
            </ContentWrapper>

             <ContentWrapper>
                <Typography variant="h4" gutterBottom>
                    Other Options
                </Typography>
                <br />



                {/* { !!requiredFields.length && <>  
                    <Typography variant="h5" gutterBottom>
                        Required Options
                    </Typography>
                    <br />

                    {requiredFields.map((field, index) => {
                        return (
                            <Row editable={false} control={control} index={index} fieldData={field} setTotalPrice={setTotalPrice} totalPrice={totalPrice} append={append} remove={remove} /> 
                    )})}

                    <br />
                    <Divider />
                    <br />
                    <Typography variant="h5" gutterBottom>
                        Optional Options
                    </Typography>
                    <br />
                </>} */}

                {/* { !optionalFields.length ? 
                    <Button
                        variant='contained'
                        color='primary'
                        type="button"
                        onClick={() => append({ isOptional: true })}
                    >
                        Add an Option
                    </Button> :
                    <>
                        {optionalFields.map((field, index) => {
                            return (
                                <Row editable={true} control={control} index={index} fieldData={field} setTotalPrice={setTotalPrice} totalPrice={totalPrice} append={append} remove={remove} /> 
                        )})}
                    </>
                } */}
                        
                { !fields.length ? 
                    <Button
                        variant='contained'
                        color='primary'
                        type="button"
                        onClick={() => append()}
                    >
                        Add an Option
                    </Button> :
                    <>
                        {fields.map((field, index) => {
                            return (
                                <Row editable={true} control={control} index={index} fieldData={field} setTotalPrice={setTotalPrice} totalPrice={totalPrice} append={append} remove={remove} /> 
                        )})}
                    </>
                }

                <br />
                <br />
                <Divider />
                <br />
                <div style={{display: 'flex'}}>
                    <TextField
                        label='Total Price'
                        type='text'
                        disabled={true}
                        className={classes.disabledInput}
                        variant='outlined' 
                        InputLabelProps={{ shrink: true }} 
                        size='small'
                        value={calcTotalPrice()}
                        style={{width: '215px', marginLeft: 'auto'}}
                        InputProps={{
                            inputComponent: NumberFormat,
                        }}
                    />
                </div>
            </ContentWrapper>
        </>
    );
};